import { render, staticRenderFns } from "./CreateEditSetorModal.vue?vue&type=template&id=52992f74&"
import script from "./CreateEditSetorModal.vue?vue&type=script&lang=js&"
export * from "./CreateEditSetorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports